import {
	OMSAPI
} from 'xbed-api'
import config from '../config'

const devAPI = new OMSAPI(true, {
	gatewayUrl: config.dev.gatewayAPI,
	ljhUrl: config.dev.ljhUrl,
	edition: 'v1.0',
	goods: 'OMS',
	terrace: 'OMS',
	materialUrl: config.dev.materialUrl,
	phpUrl: config.dev.phpUrl,
	elongUrl: config.dev.elongUrl,
	toolUrl: config.dev.toolUrl,
	clientServerUrl: config.dev.clientServerUrl
})
const qaAPI = new OMSAPI(true, {
	gatewayUrl: config.qa.gatewayAPI,
	ljhUrl: config.qa.ljhUrl,
	edition: 'v1.0',
	goods: 'OMS',
	terrace: 'OMS',
	materialUrl: config.dev.materialUrl,
	phpUrl: config.qa.phpUrl,
	elongUrl: config.qa.elongUrl,
	toolUrl: config.dev.toolUrl,
	clientServerUrl: config.qa.clientServerUrl
})
const ljhtestAPI = new OMSAPI(true, {
	gatewayUrl: config.ljhtest.gatewayAPI,
	ljhUrl: config.ljhtest.ljhUrl,
	edition: 'v1.0',
	goods: 'OMS',
	terrace: 'OMS',
	materialUrl: config.dev.materialUrl,
	phpUrl: config.ljhtest.phpUrl,
	elongUrl: config.ljhtest.elongUrl,
	toolUrl: config.dev.toolUrl,
	clientServerUrl: config.ljhtest.clientServerUrl
})
const stagingk8sAPI = new OMSAPI(true, {
	gatewayUrl: config.stagingk8s.gatewayAPI,
	ljhUrl: config.stagingk8s.ljhUrl,
	edition: 'v1.0',
	goods: 'OMS',
	terrace: 'OMS',
	materialUrl: config.dev.materialUrl,
	phpUrl: config.stagingk8s.phpUrl,
	elongUrl: config.stagingk8s.elongUrl,
	toolUrl: config.dev.toolUrl,
	clientServerUrl: config.stagingk8s.clientServerUrl
})
const prepareAPI = new OMSAPI(false, {
	gatewayUrl: config.prepare.gatewayAPI,
	ljhUrl: config.prepare.ljhUrl,
	edition: 'v1.0',
	goods: 'OMS',
	terrace: 'OMS',
	materialUrl: config.dev.materialUrl,
	phpUrl: config.prepare.phpUrl,
	elongUrl: config.prepare.elongUrl,
	toolUrl: config.dev.toolUrl,
	clientServerUrl: config.prepare.clientServerUrl
})
const productionk8sAPI = new OMSAPI(true, {
	gatewayUrl: config.productionk8s.gatewayAPI,
	ljhUrl: config.productionk8s.ljhUrl,
	edition: 'v1.0',
	goods: 'OMS',
	terrace: 'OMS',
	materialUrl: config.dev.materialUrl,
	phpUrl: config.productionk8s.phpUrl,
	elongUrl: config.productionk8s.elongUrl,
	toolUrl: config.dev.toolUrl,
	clientServerUrl: config.productionk8s.clientServerUrl
})
const releaseAPI = new OMSAPI(false, {
	gatewayUrl: config.release.gatewayAPI,
	ljhUrl: config.release.ljhUrl,
	edition: 'v1.0',
	goods: 'OMS',
	terrace: 'OMS',
	materialUrl: config.dev.materialUrl,
	phpUrl: config.release.phpUrl,
	elongUrl: config.release.elongUrl,
	toolUrl: config.dev.toolUrl,
	clientServerUrl: config.release.clientServerUrl
})
const otherAPI = new OMSAPI(true, {
	gatewayUrl: config.other.gatewayAPI,
	ljhUrl: config.other.ljhUrl,
	edition: 'v1.0',
	goods: 'OMS',
	terrace: 'OMS',
	materialUrl: config.other.materialUrl,
	phpUrl: config.other.phpUrl,
	elongUrl: config.other.elongUrl,
	toolUrl: config.dev.toolUrl,
	clientServerUrl: config.other.clientServerUrl
})

export default {
	omsAPI: {
		dev: devAPI,
		qa: qaAPI,
		ljhtest: ljhtestAPI,
		stagingk8s: stagingk8sAPI,
		productionk8s: productionk8sAPI,
		prepare: prepareAPI,
		release: releaseAPI,
		other: otherAPI
	}
}



// WEBPACK FOOTER //
// ./src/api/index.js